import React from 'react';

import { AppIcon, AppIcons } from '@backrs_ui/common-ui';

import type { IconName } from '@backrs_ui/grow-ui/src/pages/MajorsGuide/content/types';

// Map IconName type to AppIcon iconName
const ICON_NAME_MAP: Record<IconName, AppIcons> = {
  BookOpen01: 'BookOpen01',
  Users01: 'Users01',
  TrendUp01: 'TrendUp01',
  Clock: 'Clock',
  MarkerPin01: 'MarkerPin01',
  CurrencyDollarCircle: 'CurrencyDollarCircle',
  Briefcase02: 'Briefcase02',
  Award03: 'Award03',
  Target04: 'Target04',
  GraduationHat02: 'GraduationHat02',
  Settings01: 'Settings01',
  Palette: 'Palette',
  SunSetting02: 'SunSetting02',
  Heart: 'Heart',
  BellRinging01: 'BellRinging01',
  Scales01: 'Scales01',
  Building07: 'Building07',
  SearchMd: 'SearchMd',
  ChevronRight: 'ChevronRight',
  ArrowRight: 'ArrowRight',
};

// Map size numbers to AppIcon diameter strings
const SIZE_MAP: Record<number, '16px' | '20px' | '24px' | '28px' | '32px'> = {
  16: '16px',
  20: '20px',
  24: '24px',
  28: '28px',
  32: '32px',
};

/**
 * Maps IconName strings to AppIcon components
 */
export const getIcon = (iconName: IconName, size = 24): React.ReactNode => {
  const appIconName = ICON_NAME_MAP[iconName];

  if (!appIconName) {
    console.warn(`Icon "${iconName}" not found in icon map`);

    return null;
  }

  const diameter = SIZE_MAP[size] || '24px';

  return <AppIcon iconName={appIconName} diameter={diameter} color="currentColor" />;
};
